import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { shardRepositoryActions } from "redux/actions/shard-repository";
import { IAppState } from "redux/reducers";
import { useField } from "utils/form-utils";
import { ConfirmDialog } from "components/shared-ui/dialogs/common/confirm-dialog/confirm-dialog";
import TextInput from "components/shared-ui/input/text-input/text-input";
import styles from "./delete-confirmation.module.scss";


const mapDispatchToProps = (
  dispatch: ThunkDispatch<IAppState, void, Action>
) => {
  return {
    closeDeleteConfirmation: () => {
      dispatch(shardRepositoryActions.deleteConfirmation.close());
    }
  };
};

const mapStateToProps = (state: IAppState) => ({
  isOpen: state.shardRepository.deleteConfirmation.isOpen,
  data: state.shardRepository.deleteConfirmation.data,
});

export interface IDeleteConfirmationProps extends 
    ReturnType<typeof mapDispatchToProps>,
    ReturnType<typeof mapStateToProps> {

  onDelete: (storageNodeId: string) => void;
}

export const DeleteConfirmation = connect(mapStateToProps, mapDispatchToProps)((props: IDeleteConfirmationProps) => {
  const deleteTextField = useField<string>("");
  const deleteText = "DELETE";

  function handleConfirm() {
    props.onDelete(props.data.id);
    props.closeDeleteConfirmation();
  }

  useEffect(() => {
    deleteTextField.init("");
    // eslint-disable-next-line
  }, [props.isOpen]);

  return (
    <ConfirmDialog
      testId="delete-node-confirmation"
      title="Delete Shard Repository"
      confirmText="Confirm"
      open={props.isOpen}
      onClose={props.closeDeleteConfirmation}
      onConfirm={handleConfirm}
      isConfirmDisabled={deleteTextField.value !== deleteText}
    >
      <div className={styles.content}>
        Are you sure you want to delete <strong>{props.data?.bucket}</strong> from Myota? All data will be lost. Type {deleteText} below to confirm.
        <TextInput
          testId="delete-input"
          className={styles["delete-text-field"]}
          placeholder="DELETE"
          field={deleteTextField}
        />
      </div>
    </ConfirmDialog>
  );
});
